import { OrderNote } from "src/types/order-note";
import * as mvteAPI from "src/api/mvte.api";
import { useEffect, useState } from "react";
import { Table } from "src/components/table";
import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";

export function OrderNotes({ orderNumber }: { orderNumber: string | null }) {
    const [orderNotes, setOrderNotes] = useState<OrderNote[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (orderNumber === null) return;

        setIsLoading(true);

        mvteAPI.fetchOrderNotes({ orderNumber }).then((data) => {
            setOrderNotes(data);
            setIsLoading(false);
        });
    }, [orderNumber]);

    const orderNotesColumnHelper = createColumnHelper<OrderNote>();

    ////Set OrderNotes Table Columns
    const orderNotesColumns = [
        orderNotesColumnHelper.accessor("noteDatetimeUTC", {
            header: "Datetime",
            cell: (info) => {
                return dayjs(info.getValue()).format("MM/D/YYYY h:mm A");
            },
            size: 170,
        }),
        orderNotesColumnHelper.accessor("noteText", {
            header: "Note",
            cell: (info) => info.getValue(),
        }),
        orderNotesColumnHelper.accessor("noteType", {
            header: "Type",
            cell: (info) => info.getValue(),
        }),
        orderNotesColumnHelper.accessor("employeeCode", {
            header: "Employee",
            cell: (info) => info.getValue(),
        }),
    ];

    if (!orderNumber) {
        return (
            <div className="bg-white rounded-sm p-3 h-full flex items-center justify-center text-gray-500">
                Select order number to view note details
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="bg-white rounded-sm p-3 h-full flex items-center justify-center text-gray-500">
                <span>Loading note information...</span>
            </div>
        );
    }

    if (orderNotes.length === 0) {
        return (
            <div className="bg-white rounded-sm p-3 h-full flex items-center justify-center text-gray-500">
                No notes found for order #{orderNumber}
            </div>
        );
    }

    return (
        <div className="rounded-sm overflow-y-auto h-full">
            <Table
                data={orderNotes}
                columns={orderNotesColumns}
                containerClassName="order-notes"
                pageSize={10}
                enablePagination={false}
                tableSize="xs"
                title="Order Notes"
            />
        </div>
    );
}
